import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/internal-backend-integration/page.tsx");
